// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__3ZHm-","empty":"ModalGraph_empty__33OmT"};